<template>
    <div class="AdminRole">

        <v-container>

            <v-layout justify-center align-center column>

                <v-flex xs12>
                    <v-img></v-img>
                </v-flex>

                <v-flex xs12>
                    <p class="mb-0 grey--text text--darken-1 display-1 text-xs-center">Admin Controls</p>
                    <p class="font-weight-light grey--text text--lighten-1 caption text-xs-center">Give Specific Users Admin</p>
                </v-flex>

                <v-flex xs12>
                    <v-text-field label="Email Address" v-model="email"> </v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-btn @click="submitAdmin" depressed color="green lighten-3 white--text">
                        <span>Make Admin</span>
                    </v-btn>
                </v-flex>

                <v-snackbar v-model="success" bottom right :timeout="2000">
                    Succesfully made Admin!
                </v-snackbar>

            </v-layout>

        </v-container>

    </div>
</template>

<script>
import {functions} from '@/fb.js';
const addInRef = functions.httpsCallable('addAdminRole'); //reference to whatever function where calling
export default {
    data() {
        return {
            email: '',
            success: false
        }
    },
    methods: {
        submitAdmin() {
            addInRef({email: this.email}).then((data) => {
                console.log(data);
                this.success = true;
            });
        }
    }
}
</script>